<script lang="ts">
  import Brand from '../../components/Brand.svelte';
  import { router } from '../../lib/router.svelte';
  import { adminSession } from '../../lib/session.svelte';
  let { children } = $props();
  let mobileOpen = $state(false);
  const path = $derived(router.state.path);
  const links = [
    ['/admin', 'Overview', '⌂'],
    ['/admin/bookings', 'Bookings', '▣'],
    ['/admin/packages', 'Packages', '▤'],
    ['/admin/inventory', 'Inventory', '▧'],
    ['/admin/content', 'Website content', '✎'],
    ['/admin/promotions', 'Promotions', '％'],
    ['/admin/agreements', 'Agreements', '✓'],
    ['/admin/reviews', 'Reviews', '★'],
    ['/admin/integrations', 'Integrations', '↗'],
    ['/admin/settings', 'Settings', '⚙'],
  ] as const;
  function active(href: string) { return href === '/admin' ? path === href : path.startsWith(href); }
  async function logout() { await adminSession.signOut(); router.navigate('/admin/login', true); }

  // The sidebar is visually hidden below the lg breakpoint; when it is, it must
  // also be unreachable by keyboard (`d-lg-none` alone leaves it tabbable).
  let collapsed = $state(false);
  let closeButton = $state<HTMLButtonElement | null>(null);
  let menuButton = $state<HTMLButtonElement | null>(null);

  $effect(() => {
    const media = window.matchMedia('(max-width: 991.98px)');
    const sync = () => { collapsed = media.matches; };
    sync();
    media.addEventListener('change', sync);
    return () => media.removeEventListener('change', sync);
  });

  $effect(() => {
    if (mobileOpen) closeButton?.focus();
  });

  $effect(() => {
    if (!mobileOpen || !collapsed) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;
      mobileOpen = false;
      menuButton?.focus();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  });
</script>
<div class="admin-root">
  <a class="skip-link" href="#admin-content">Skip to main content</a>
  <aside id="admin-sidebar" class:mobile-open={mobileOpen} inert={!mobileOpen && collapsed} class="admin-sidebar">
    <div class="d-flex align-items-center justify-content-between"><Brand compact /><button class="btn btn-sm btn-light d-lg-none" aria-label="Close navigation menu" bind:this={closeButton} onclick={() => mobileOpen=false}>×</button></div>
    <nav class="admin-nav" aria-label="Admin navigation">
      {#each links as link}
        <a href={link[0]} data-spa class:active={active(link[0])} onclick={() => mobileOpen=false}><span class="nav-bullet"></span><span aria-hidden="true" class="admin-nav-icon">{link[2]}</span>{link[1]}</a>
      {/each}
    </nav>
    <div class="mt-auto pt-3 border-top">
      <button class="btn btn-light w-100 text-start" onclick={logout}>Sign out</button>
    </div>
  </aside>
  <div class="admin-main">
    <header class="admin-topbar"><div class="d-flex align-items-center gap-3 px-3 px-lg-4 py-3"><button class="btn btn-light d-lg-none" aria-label="Open navigation menu" aria-controls="admin-sidebar" aria-expanded={mobileOpen} bind:this={menuButton} onclick={() => mobileOpen=true}>☰</button><div><strong class="display-font">Bibow operations</strong><div class="small text-secondary d-none d-sm-block">Bookings, content and day-to-day management</div></div><a href="/" class="btn btn-sm btn-outline-secondary ms-auto" target="_blank" rel="noopener">View website ↗</a></div></header>
    <main id="admin-content" class="admin-content" tabindex="-1">{@render children()}</main>
  </div>
</div>
